// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frisbuy-sr-branding[data-v-f7983956]{width:-moz-fit-content;width:fit-content;color:#fff;text-decoration:none;font-size:10px;line-height:12px}.frisbuy-sr-branding span[data-v-f7983956]{display:flex;align-items:center;background-color:rgba(0,0,0,.2);border-radius:10%;padding:2px 4px}.frisbuy-sr-branding svg[data-v-f7983956]{overflow:visible;margin-left:9px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
